import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const FactorsTable = ({ factors, onRemove, onUpdate }) => {
    console.log(factors);
    const rows = factors.map((factor, index) => <Row key={index} factor={factor} onUpdate={onUpdate} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th>Country</th>
                    <th>Factor</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default FactorsTable;


// WEBPACK FOOTER //
// ./src/scenes/PushapiCountry/components/Table/index.js